module.exports = __webpack_public_path__ + "img/2.33317310.png";